import { gql } from '@apollo/client';
import { Questionnaire } from '../Common';

export const getQuestionnaire = gql`
  query ($id: uuid!) {
    dans_fund_questionnaire_by_pk(id: $id) {
      id
      name
      questions
      send_to
    }
  }
`;

export interface GetQuestionnaireResponse {
  dans_fund_questionnaire_by_pk: Questionnaire;
}
